// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import TextField from 'material-ui/TextField';

import TitledCard from 'common/components/cards/TitledCard';
import { Label } from '../styles';
import type { RadioInformationFormSection, WebAgencyData } from '../../domain/RadioInformationForm';

type Props = {
  onChange: (value: RadioInformationFormSection) => void,
  data: WebAgencyData,
  t: any,
}

function WebAgency(props: Props) {
  return (
    <TitledCard title={props.t('webAgency')}>
      <div className="row">
        <div className="col-xs-8">
          <Label>{props.t('webAgencyName')}</Label>
          <TextField
            name="webAgencyName"
            onChange={(e, v) => props.onChange({ ...props.data, webAgencyName: v })}
            value={props.data.webAgencyName}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('webAgencyDirector')}</Label>
          <TextField
            name="webAgencyDirector"
            onChange={(e, v) => props.onChange({ ...props.data, webAgencyDirector: v })}
            value={props.data.webAgencyDirector}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('phone')}</Label>
          <TextField
            name="webAgencyPhone"
            onChange={(e, v) => props.onChange({ ...props.data, webAgencyPhone: v })}
            value={props.data.webAgencyPhone}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('email')}</Label>
          <TextField
            name="webAgencyEmail"
            onChange={(e, v) => props.onChange({ ...props.data, webAgencyEmail: v })}
            value={props.data.webAgencyEmail}
            fullWidth
          />
        </div>
      </div>
    </TitledCard>
  );
}

export default translate('radioConfiguration')(WebAgency);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/radioInformationForm/WebAgency.js